"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissionDocumentType = void 0;
var MissionDocumentType;
(function (MissionDocumentType) {
    MissionDocumentType["AFTO_781_V1"] = "afto_781_v1";
    MissionDocumentType["AF_1522_V1"] = "af_1522_v1";
    MissionDocumentType["AF_3956_V1"] = "af_3956_v1";
})(MissionDocumentType = exports.MissionDocumentType || (exports.MissionDocumentType = {}));
